"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgIcon_1 = __importDefault(require("@material-ui/core/SvgIcon"));
var NumberManagerIcon = function (props) {
    // Included due to svg size
    var defaults = __assign({ viewBox: "0 0 200 200" }, props);
    return (react_1.default.createElement(SvgIcon_1.default, __assign({}, defaults),
        react_1.default.createElement("g", { transform: "translate(0,175) scale(0.1,-0.1)" },
            react_1.default.createElement("path", { d: "M905 1354 c-316 -47 -535 -213 -647 -493 -18 -43 -35 -68 -55 -81\n-51 -31 -73 -67 -73 -122 0 -82 34 -129 110 -149 40 -11 51 -10 92 9 53 23 78\n55 85 111 7 54 -2 84 -38 126 l-31 35 27 55 c40 82 115 159 193 197 64 32 71\n33 187 33 114 0 123 -2 187 -32 89 -42 160 -110 200 -190 l31 -64 -32 -33\nc-87 -89 -43 -230 79 -251 55 -9 124 25 152 75 38 70 9 167 -60 200 -21 10\n-35 26 -43 50 -66 202 -276 358 -489 361 l-55 1 35 15 c19 8 67 21 108 29 304\n58 609 -90 743 -360 l42 -86 -25 -28 c-14 -15 -31 -37 -37 -49 -25 -50 -4\n-146 39 -176 l21 -15 -21 -43 c-30 -59 -110 -140 -168 -172 -178 -97 -396 -65\n-531 78 -27 28 -59 71 -71 94 l-22 43 27 28 c58 60 53 153 -10 209 -42 36 -73\n46 -123 37 -135 -22 -167 -209 -45 -271 32 -16 46 -33 73 -88 85 -177 275\n-291 485 -291 210 0 397 112 481 287 26 56 42 76 69 90 50 25 75 70 75 134 0\n44 -5 58 -30 86 -16 19 -43 40 -60 47 -17 7 -30 20 -30 29 0 32 -81 184 -131\n248 -99 123 -254 222 -415 263 -76 20 -239 33 -299 24z" }))));
};
exports.default = NumberManagerIcon;
